import axios from 'axios';
import {
    END_POINT,
    END_STATIC_POINT
} from '../constants/config';

// const CLIENT_ID = 2;
// const CLIENT_SECRET = 'TBfyIXm0WD0flbghXarrpwUTlvQ9dukaWMa8GMD3';
const API_TOKEN = 'uw1eqXPNp3SPTb6bOeNT47EkPSu3hRz5Ke6D4zJQ';
const API_DOMAIN = END_POINT;
let token = sessionStorage.getItem('token');
let DEFAULT_HEADERS = {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json;charset=UTF-8',
    'Accept': 'application/json, text/plain, */*',
    'Access-Control-Allow-Origin': '*'
};

function setAuthorization(auth) {
    DEFAULT_HEADERS.Authorization = `Bearer ${auth}`;
}

function get(url) {
    return axios.get(`${API_DOMAIN}${url}`, {
        headers: DEFAULT_HEADERS,
        crossDomain: true
    });
}

function post(url, data) {
    return axios.post(`${API_DOMAIN}${url}`, data, {
        headers: DEFAULT_HEADERS,
        crossDomain: true
    });
}

function staticPost(url, data) {
    return axios.post(`${END_STATIC_POINT}${url}`, data, {
        headers: DEFAULT_HEADERS,
        crossDomain: true
    });
}

function put(url, data) {
    return axios.put(`${API_DOMAIN}${url}`, data, {
        headers: DEFAULT_HEADERS,
        crossDomain: true
    });
}

function del(url) {
    return axios.delete(`${API_DOMAIN}${url}`, {
        headers: DEFAULT_HEADERS,
        crossDomain: true
    });
}

function rs(res) {
    return res.data
}

// api calls
function login(data, success, fail) {
    const payload = Object.assign({}, data, {
        outh_param: data.username
    });
    post(`/api/auth/login-with-password`, payload).then(success, fail);
}

function getUserInfo(onLoad) {
    get('/api/management/user').then(onLoad);
}

// brands

function getAllBrands(query = ``, onLoad) {
    return get(`/api/management/brands/getAll`).then(res => {
        onLoad(rs(res))
    })
}

function getStoresList(query = ``, onLoad) {
    get(`/api/management/brands?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function getStoresListPaginate(query = ``, onLoad) {
    get(`/api/management/brands/paginate?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function getStoresCount(query = ``, onLoad) {
    get(`/api/management/brands/count?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function uploadLogo(data, onLoad) {
    const form = new FormData();
    form.append('file', data.file.originFileObj);
    form.append('path', 'logo');
    form.append('api_token', API_TOKEN)
    staticPost(`/api/file/upload`, form)
        .then(res => {
            onLoad(rs(res))
        })
        .catch(error => {
            console.log(error)
        });;
}

function uploadNewsletterImage(data, onLoad) {
    const form = new FormData();
    form.append('file', data.file.originFileObj);
    form.append('path', 'newsletter');
    form.append('api_token', API_TOKEN)
    staticPost(`/api/file/upload`, form)
        .then(res => {
            onLoad(rs(res))
        })
        .catch(error => {
            console.log(error)
        });;
}

function uploadBanner(data, onLoad) {
    const form = new FormData();
    form.append('file', data.file.originFileObj);
    form.append('path', 'banner');
    form.append('api_token', API_TOKEN)
    staticPost(`/api/file/upload`, form)
        .then(res => {
            onLoad(rs(res))
        })
        .catch(error => {});
}

function uploadNotificationImage(data, onLoad, path = 'notification_image') {
    const form = new FormData();
    form.append('file', data.file.originFileObj);
    form.append('path', path);
    form.append('api_token', API_TOKEN)
    staticPost(`/api/file/upload`, form)
        .then(res => {
            onLoad(rs(res))
        })
        .catch(error => {});
}

function uploadCodeFile(data, onLoad) {
    const form = new FormData();
    form.append('file', data.file.originFileObj);
    post(`/api/management/files/code-file`, form).then(res => {
        onLoad(rs(res))
    });
}

function getStoreItem(id, onLoad) {
    get(`/api/management/brands/items/${id}`).then(res => onLoad(rs(res)));
}

function updateStoreItem(id, data, onLoad) {
    put(`/api/management/brands/items/${id}`, data).then(onLoad);
}

function addStoreItem(data, onLoad) {
    post(`/api/management/brands/items`, data).then(res => {
        onLoad(rs(res))
    });
}

function removeStoreItem(id, onLoad) {
    del(`/api/management/brands/items/${id}`).then(onLoad);
}

function postTag(data, onLoad) {
    post(`/api/management/tags/items`, data).then(({
        data
    }) => onLoad(data));
}

// coupons
function getCouponsList(query = ``, onLoad) {
    if (query) {
        query = encodeURI(query);
    }
    get(`/api/management/coupons?${query}`).then(onLoad);
}

// special coupons
function getSpecialCouponsList(query = ``, onLoad) {
    if (query) {
        query = encodeURI(query);
    }
    get(`/api/management/special-coupons?${query}`).then(onLoad);
}

// get all products
function getProductsList(query = ``, onLoad) {
    if(query){
        query = encodeURI(query);
    }
    get(`/api/management/products?${query}`).then(onLoad);
}

function getProductItem(id, onLoad) {
    get(`/api/management/products/get/${id}`).then(res => {
        onLoad(res.data)
    });
}

function updateProductItem(id, data, onLoad = () => {}) {
    put(`/api/management/products/items/${id}`, data).then(onLoad);
}


// jobs
function getJobsList(query = ``, onLoad) {
    if (query) {
        query = encodeURI(query);
    }
    get(`/api/jobs/list?${query}`).then(onLoad);
}

function getJobItem(id, onLoad) {
    get(`/api/jobs/get/${id}`).then(res => {
        onLoad(res.data)
    });
}

function addJobItem(data, onLoad) {
    post(`/api/jobs/add/`, data).then(res => onLoad(rs(res)));
}

function updateJobItem(id, data, onLoad = () => {}) {
    put(`/api/jobs/update/${id}`, data).then(onLoad);
}

function getCouponsCount(query, onLoad) {
    get(`/api/management/coupons/count?query=${query}`).then(onLoad);
}

function getCouponItem(id, onLoad) {
    get(`/api/management/coupons/items/${id}`).then(res => {
        onLoad(res.data)
    });
}

function updateCouponItem(id, data, onLoad = () => {}) {
    put(`/api/management/coupons/items/${id}`, data).then(onLoad);
}

function addCouponItem(data, onLoad) {
    post(`/api/management/coupons/items`, data).then(res => onLoad(rs(res)));
}

function singleCouponItem(coupon_id, onLoad) {
    get(`/api/coupon/single/`+coupon_id).then(res => onLoad(rs(res)));
}

function getCouponContent( text, coupon_id, onLoad) {
    var data = {
        text : text,
    };

    post(`/api/management/coupons/content/`+coupon_id,data).then(res => onLoad(rs(res)));
}


function submitEmailSubscription(email, brand_id,onLoad) {

    var data = {
        email : email,
        brand_id : brand_id
    };
    // var url = '/api/newsletter/subscribe';

    if (brand_id !== undefined) {
        var url = '/api/brand/subscription/' + brand_id;
        post(url,data).then(res => onLoad(rs(res)));
    }
    // post(url,data).then(res => onLoad(rs(res)));
}

function removeCouponItem(id, onLoad) {
    del(`/api/management/coupons/items/${id}`).then(onLoad);
}
// categories

function getCategoriesList(onLoad) {
    get(`/api/management/categories`).then(onLoad);
}

// contact us
function getContactUsList(query, onLoad) {
    get(`/api/management/contact?${query}`).then(res => onLoad(rs(res)));
}

function getContactUsCount(query, onLoad) {
    get(`/api/management/contact/count?${query}`).then(res => onLoad(rs(res)));
}

function removeContactUsItem(id, onLoad) {
    del(`/api/management/contact/items/${id}`).then(res => onLoad(rs(res)));
}

// Users

function getUsers(query, onLoad) {
    get(`/api/management/users?${query}`).then(res => onLoad(res.data));
}

function getRolesList(onLoad) {
    get(`/api/management/users/roles`).then(res => onLoad(res.data));
}

function getPermissions(query, onLoad) {
    get(`/api/management/users/permissions?` + query).then(res => onLoad(res.data));
}

function removeUser(id, onLoad) {
    del(`/api/management/users/items/${id}`).then(res => onLoad(res.data));
}

function getUserDetail(id, onLoad) {
    get(`/api/management/users/items/${id}`).then(res => onLoad(res.data));
}

function updateUser(id, data, onLoad) {
    put(`/api/management/users/items/${id}`, data).then(res => onLoad(res.data));
}

// Newsletter

function getNewsletterSubscribersList(query, onLoad) {
    get(`/api/management/newsletters/subscribers?${query}`).then(res => onLoad(res.data));
}

function removeNewsletterSubscriberItem(id, onLoad) {
    del(`/api/management/newsletters/${id}`).then(res => onLoad(res.data));
}

function sendEmailToNewsletterSubscribers(data, onLoad) {
    post(`/api/management/newsletters/send-email`, data).then(res => onLoad(res.data));
}

// Store Subscribers

function getStoreSubscribers(query = ``, onLoad) {
    get(`/api/management/subscription/subscribers?${query}`).then(res => onLoad(res.data));
}

function removeStoreSubscriber(id, onLoad) {
    del(`/api/management/subscription/subscribers/${id}`).then(res => onLoad(res.data));
}

function sendEmailToStoreSubscribers(data, onLoad) {
    post(`/api/management/subscription/send-email`, data).then(res => onLoad(res.data));
}


// Logger Email

function listLoggerEmail(query, onLoad) {
    get(`/api/management/newsletters?${query}`).then(res => onLoad(rs(res.data)));
}

function getOneLoggerEmail(id, onLoad) {
    get(`/api/management/newsletters/records/${id}`).then(res => onLoad(res.data));
}

// Notifications
function addNotificationItem(data, onLoad) {
    post(`/api/management/notifications`, data).then(res => {
        onLoad(rs(res))
    });
}

function getNotificationsList(query = ``, onLoad) {
    get(`/api/management/notifications?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function sendTestNotification(id, onLoad) {
    post(`/api/management/notifications/${id}/send-test`).then(res => {
        onLoad(rs(res))
    });
}

function publishNotification(id, onLoad) {
    put(`/api/management/notifications/${id}/publish`).then(res => {
        onLoad(rs(res))
    });
}

// Events
function addEventItem(data, onLoad) {
    post(`/api/management/events/items`, data).then(res => {
        onLoad(rs(res))
    });
}

function updateEventItem(id, data, onLoad) {
    put(`/api/management/events/items/${id}`, data).then(onLoad);
}

function getEventsList(query = ``, onLoad) {
    get(`/api/management/events?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function getEventsCount(query = ``, onLoad) {
    get(`/api/management/events/count?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function getEventItem(id, onLoad) {
    get(`/api/management/events/items/${id}`).then(res => onLoad(rs(res)));
}

function removeEventItem(id, onLoad) {
    del(`/api/management/events/items/${id}`).then(onLoad);
}


// Popular Stores
function addPopularStoreItem(data, onLoad) {
    post(`/api/management/popular/items`, data).then(res => {
        onLoad(rs(res))
    });
}

function updatePopularStoreItem(data, onLoad) {
    put(`/api/management/popular/items`, data).then(onLoad);
}

function getPopularStoresList(query = ``, onLoad) {
    get(`/api/management/popular?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function getPopularStoreItem(id, onLoad) {
    get(`/api/management/popular/items/${id}`).then(res => onLoad(rs(res)));
}

function removePopularStoreItem(id, onLoad) {
    del(`/api/management/popular/items/${id}`).then(onLoad);
}

// Wall
function getWallCouponsList(query = ``, onLoad) {
    get(`/api/management/wall?${query}`).then(res => onLoad(rs(res)));
}

function getWallCouponsItem(id, onLoad) {
    get(`/api/management/wall/items/${id}`).then(res => onLoad(rs(res)));
}

function updateWallCouponsItem(id, data, onLoad) {
    put(`/api/management/wall/items/${id}`, data).then(onLoad);
}

function changeStatusWallCoupons(id, data, onLoad) {
    put(`/api/management/wall/items/change-status/${id}`, data).then(onLoad);
}

function makeExpireWallCoupons(id, data, onLoad) {
    put(`/api/management/wall/items/expire/${id}`, data).then(onLoad);
}

function removeWallItem(id, onLoad) {
    del(`/api/management/wall/items/${id}`).then(onLoad);
}

// Sliders
function addSliderItem(data, onLoad) {
    post(`/api/management/sliders/items`, data).then(res => {
        onLoad(rs(res))
    });
}

function updateSliderItem(id, data, onLoad) {
    put(`/api/management/sliders/items/${id}`, data).then(onLoad);
}

function dndSlider(data, onLoad) {
    put(`/api/management/sliders/dnd`, data).then(onLoad);
}

function getSlidersList(query = ``, onLoad) {
    get(`/api/management/sliders?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function getSliderItem(id, onLoad) {
    get(`/api/management/sliders/items/${id}`).then(res => onLoad(rs(res)));
}

function removeSliderItem(id, onLoad) {
    del(`/api/management/sliders/items/${id}`).then(onLoad);
}

function uploadSlider(data, onLoad, type = null,slider_type = null) {

    const form = new FormData();
    form.append('file', data.file.originFileObj);
    form.append('path', 'slider');
    form.append('quality', '100');
    if (type != null && type == 1) {
        form.append('type', 'slider');
        form.append('slider_type', slider_type);

        sliderStaticPost(`/api/management/upload/to-webp`, form).then(res => {
            onLoad(rs(res))
        });
    }else if(slider_type!==null){
        form.append('slider_type', slider_type);

        sliderStaticPost(`/api/management/upload/to-webp`, form).then(res => {
            onLoad(rs(res))
        });
    }else {
        form.append('api_token', API_TOKEN);
        staticPost(`/api/file/upload`, form).then(res => {
            onLoad(rs(res))
        });
    }
}

function sliderStaticPost(url, data) {
    return axios.post(`${END_POINT}${url}`, data, {
        headers: DEFAULT_HEADERS,
        crossDomain: true
    });
}

function uploadPageFile(data, onLoad) {
    const form = new FormData();
    form.append('file', data.file.originFileObj);
    form.append('path', 'pages');
    form.append('api_token', API_TOKEN)
    staticPost(`/api/file/upload`, form).then(res => {
        onLoad(rs(res))
    });
}

function uploader(data, path, onLoad) {
    const form = new FormData();
    form.append('file', data.file.originFileObj);
    form.append('path', path);
    form.append('api_token', API_TOKEN)
    staticPost(`/api/file/upload`, form).then(res => {
        onLoad(rs(res))
    });
}

function getWorkWithUsList(query = ``, onLoad) {
    get(`/api/management/work-with-us?${query}`).then(res => {
        onLoad(rs(res))
    });
}


function removeWorkUsItem(id, onLoad) {
    del(`/api/management/work-with-us/items/${id}`).then(onLoad);
}

function getDashboard(query = ``, onLoad) {
    get(`/api/management/admin-dashboard?${query}`).then(res => {
        onLoad(res)
    });
}

function getCategoriesV2List(query = ``, onLoad) {
    get(`/api/management/categories?${query}`).then(res => {
        onLoad(rs(res.data))
    });
}

function getOneCategoryV2(id, onLoad) {
    get(`/api/management/categories/${id}`).then(res => {
        onLoad(rs(res.data))
    });
}

function createNewSubcategory(data, onLoad) {
    return post(`/api/management/categories`, data).then(res => {
        onLoad(rs(res))
    });
}

function updateSubcategory(id, data, onLoad) {
    return put(`/api/management/categories/${id}`, data).then(res => {
        onLoad(rs(res))
    });
}

function removeSubcategory(id, onLoad) {
    del(`/api/management/categories/${id}`).then(onLoad);
}


// Application
function updateAppHomeSetting(data, onLoad) {
    return post(`/api/management/application/home`, data).then(res => {
        onLoad(rs(res))
    });
}

function getAppHomeSetting(onLoad) {
    get(`/api/management/application/home`).then(res => {
        onLoad(rs(res))
    });
}

// Bulk Message (SMS)
function getBulkMessageList(query = ``, onLoad) {
    get(`/api/management/sms?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function createBulkMessage(data, onLoad) {
    return post(`/api/management/sms`, data).then(res => {
        onLoad(rs(res))
    });
}

// History (Change logs)
function getHistoryList(uri = '', query = '', onLoad) {
    get(`/api/management/history/${uri}?${query}`).then(res => {
        onLoad(rs(res))
    });
}


// Comments
function removeCommentItem(id, onLoad) {
    del(`/api/management/comments/items/${id}`).then(onLoad);
}

function getCommentsListPaginate(query = ``, onLoad) {
    get(`/api/management/comments?${query}`).then(res => {
        onLoad(rs(res))
    });
}

function editCommentItem(id, data, onLoad) {
    put(`/api/management/comments/items/${id}`, data).then(onLoad);
}


//Pages
function getPagesList(onLoad, query = ``) {
    if (query) {
        query = encodeURI(query);
    }
    get(`/api/management/pages?${query}`).then(onLoad);
}

function getPageItem(slug, onLoad) {
    get(`/api/management/pages/${slug}`).then(onLoad);
}

function updatePageItem(slug, data, onLoad = () => {}) {
    put(`/api/management/pages/${slug}`, data).then(onLoad);
}

//Acl
function getRoleItem(id, onLoad) {
    get(`/api/management/users/roles/${id}`).then(res => onLoad(rs(res)));
}

function removeRoleItem(id, onLoad) {
    del(`/api/management/users/roles/${id}`).then(res => onLoad(rs(res)));
}

function addRoleItem(data, onLoad) {
    post(`/api/management/users/roles`, data).then(res => {
        onLoad(rs(res))
    });
}

function updateRoleItem(id, data, onLoad = () => {}) {
    put(`/api/management/users/roles/${id}`, data).then(onLoad);
}

//Referral
function getReferralSettings(onLoad) {
    get(`/api/management/referral`).then(res => onLoad(rs(res)));
}

function getReferralSetting(id, onLoad) {
    get(`/api/management/referral/${id}`).then(res => onLoad(rs(res)));
}

function updateReferralSetting(id, data, onLoad = () => {}) {
    put(`/api/management/referral/${id}`, data).then(onLoad);
}


//LuckyWheel
function getLuckyWheels(onLoad) {
    get(`/api/management/lucky-wheels`).then(res => onLoad(rs(res)));
}

function getLuckyWheel(id, onLoad) {
    get(`/api/management/lucky-wheels/${id}`).then(res => onLoad(rs(res)));
}

function updateLuckyWheel(id, data, onLoad = () => {}) {
    put(`/api/management/lucky-wheels/${id}`, data).then(onLoad);
}

function addLuckyWheel(data, onLoad) {
    post(`/api/management/lucky-wheels`, data).then(onLoad);
}

function getLuckyWheelCoupons(lucky_wheel_id, onLoad) {
    get(`/api/management/lucky-wheels/coupons/${lucky_wheel_id}`).then(res => onLoad(rs(res)));
}

function getLuckyWheelCoupon(lucky_wheel_id, id, onLoad) {
    get(`/api/management/lucky-wheels/coupons/${lucky_wheel_id}/${id}`).then(res => onLoad(rs(res)));
}

function updateLuckyWheelCoupon(lucky_wheel_id, id, data, onLoad = () => {}) {
    put(`/api/management/lucky-wheels/coupons/${lucky_wheel_id}/${id}`, data).then(onLoad);
}

function addLuckyWheelCoupon(lucky_wheel_id, data, onLoad) {
    post(`/api/management/lucky-wheels/coupons/${lucky_wheel_id}`, data).then(onLoad);
}

function div(a, b) {
    return parseInt((a / b));
}

function gregorian_to_jalali(g_y, g_m, g_d) {
    var g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
    var jalali = [];
    var gy = g_y - 1600;
    var gm = g_m - 1;
    var gd = g_d - 1;

    var g_day_no = 365 * gy + div(gy + 3, 4) - div(gy + 99, 100) + div(gy + 399, 400);

    for (var i = 0; i < gm; ++i)
        g_day_no += g_days_in_month[i];
    if (gm > 1 && ((gy % 4 == 0 && gy % 100 != 0) || (gy % 400 == 0)))
        /* leap and after Feb */
        g_day_no++;
    g_day_no += gd;

    var j_day_no = g_day_no - 79;

    var j_np = div(j_day_no, 12053);
    /* 12053 = 365*33 + 32/4 */
    j_day_no = j_day_no % 12053;

    var jy = 979 + 33 * j_np + 4 * div(j_day_no, 1461);
    /* 1461 = 365*4 + 4/4 */

    j_day_no %= 1461;

    if (j_day_no >= 366) {
        jy += div(j_day_no - 1, 365);
        j_day_no = (j_day_no - 1) % 365;
    }
    for (var i = 0; i < 11 && j_day_no >= j_days_in_month[i]; ++i)
        j_day_no -= j_days_in_month[i];
    var jm = i + 1;
    var jd = j_day_no + 1;
    jalali[0] = jy;
    jalali[1] = jm;
    jalali[2] = jd;
    //     return jalali;
    //return jalali[0] + "_" + jalali[1] + "_" + jalali[2];
    return jy + "/" + jm + "/" + jd;
}

function get_year_month_day(date) {
    var convertDate;
    var y = date.substr(0, 4);
    var m = date.substr(5, 2);
    var d = date.substr(8, 2);
    convertDate = gregorian_to_jalali(y, m, d);
    return convertDate;
}

function get_hour_minute_second(time) {
    var convertTime = [];
    convertTime[0] = time.substr(0, 2);
    convertTime[1] = time.substr(3, 2);
    convertTime[2] = time.substr(6, 2);
    return convertTime;
}

function convertDate(date) {
    var convertDateTime = get_year_month_day(date.substr(0, 10));
    convertDateTime = convertDateTime[0] + "/" + convertDateTime[1] + "/" + convertDateTime[2] + " " + date.substr(10);
    return convertDateTime;
}

function get_persian_month(month) {
    switch (month) {
        case 1:
            return "فروردین";
            break;
        case 2:
            return "اردیبهشت";
            break;
        case 3:
            return "خرداد";
            break;
        case 4:
            return "تیر";
            break;
        case 5:
            return "مرداد";
            break;
        case 6:
            return "شهریور";
            break;
        case 7:
            return "مهر";
            break;
        case 8:
            return "آبان";
            break;
        case 9:
            return "آذر";
            break;
        case 10:
            return "دی";
            break;
        case 11:
            return "بهمن";
            break;
        case 12:
            return "اسفند";
            break;
    }
}
export {
    login,
    setAuthorization,
    getUserInfo,
    getCouponsList,
    getSpecialCouponsList,
    getCouponsCount,
    removeCouponItem,
    getStoresList,
    getStoresCount,
    getStoreItem,
    addStoreItem,
    removeStoreItem,
    updateStoreItem,
    postTag,
    getCategoriesList,
    uploadLogo,
    getCouponItem,
    updateCouponItem,
    addCouponItem,
    singleCouponItem,
    getCouponContent,
    submitEmailSubscription,
    getContactUsList,
    getContactUsCount,
    removeContactUsItem,
    getUsers,
    removeUser,
    updateUser,
    getUserDetail,
    getRolesList,
    getNewsletterSubscribersList,
    removeNewsletterSubscriberItem,
    sendEmailToNewsletterSubscribers,
    getStoreSubscribers,
    removeStoreSubscriber,
    sendEmailToStoreSubscribers,
    listLoggerEmail,
    getOneLoggerEmail,
    addEventItem,
    updateEventItem,
    getEventsList,
    getEventsCount,
    getEventItem,
    removeEventItem,
    addPopularStoreItem,
    updatePopularStoreItem,
    getPopularStoresList,
    getPopularStoreItem,
    removePopularStoreItem,
    getWallCouponsList,
    getWallCouponsItem,
    updateWallCouponsItem,
    changeStatusWallCoupons,
    makeExpireWallCoupons,
    removeWallItem,
    addSliderItem,
    updateSliderItem,
    getSlidersList,
    getSliderItem,
    removeSliderItem,
    dndSlider,
    uploadSlider,
    uploadBanner,
    uploadNewsletterImage,
    getWorkWithUsList,
    removeWorkUsItem,
    getStoresListPaginate,
    getDashboard,
    getCategoriesV2List,
    createNewSubcategory,
    removeSubcategory,
    getOneCategoryV2,
    updateSubcategory,
    uploadCodeFile,
    uploadPageFile,
    uploader,
    API_TOKEN,

    updateAppHomeSetting,
    getAppHomeSetting,

    getBulkMessageList,
    createBulkMessage,

    getHistoryList,

    getCommentsListPaginate,
    removeCommentItem,
    editCommentItem,
    getPagesList,
    getPageItem,
    updatePageItem,

    getPermissions,

    getRoleItem,
    removeRoleItem,
    addRoleItem,
    updateRoleItem,
    getReferralSettings,
    getReferralSetting,
    updateReferralSetting,
    addNotificationItem,
    getNotificationsList,
    publishNotification,
    sendTestNotification,
    uploadNotificationImage,

    getLuckyWheels,
    getLuckyWheel,
    updateLuckyWheel,
    addLuckyWheel,
    getLuckyWheelCoupons,
    getLuckyWheelCoupon,
    updateLuckyWheelCoupon,
    addLuckyWheelCoupon,
    getJobsList,
    getJobItem,
    addJobItem,
    updateJobItem,
    getProductsList,
    getAllBrands,
    gregorian_to_jalali,
    updateProductItem,
    getProductItem,
};


// WEBPACK FOOTER //
// ./src/modules/Api.js